export interface GtagConfig {
  gaId: string;
  enabled: boolean;
}

export const createGtagHelpers = (config: GtagConfig) => {
  const { gaId, enabled } = config;


  const isGAEnabled = () => {
    return enabled && typeof window !== 'undefined' &&
      typeof (window as any).gtag === 'function' &&
      !document.cookie.includes('analytics_optout=true');
  };

  const pageview = (url: string) => {
    if (!isGAEnabled()) return;
    if (typeof window === 'undefined') return;
    (window as any).gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: url,
    });
  };

  const event = ({ action, ...params }: { action: string;[key: string]: string | number | boolean }) => {
    if (!isGAEnabled()) return;
    (window as any).gtag('event', action, params);
  };

  return {
    gaId,
    isGAEnabled,
    pageview,
    event
  };
};
